// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3YYEv","requiredAsterisk":"Info_requiredAsterisk__3T6Zl"};